import React, { Component } from "react";
import { Div, Image, Text, Button, Row, Col } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";

import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";
import AnimateLink from "../common/AnimateLink";
import { Link } from "gatsby";
import { IsValidUrl } from "../../utilities/helpers";

const buzzVideoParams = {
  // fluid: false,
  playsInline: true,
  autoPlay: false,
  isFullscreen: true,
};

export default class BuzzMoon extends Component {
  render() {
    const { content } = this.props;
    return (
      <Div>
        <Div
          bgImg={content.bgImg}
          bgSize="cover"
          bgPos="center"
          p={{ t: "10.1rem", b: "5.1rem" }}
        >
          <WebsiteContainer>
            <CustomContainer>
              <Row>
                <Col size={{ xs: "12", md: "5" }}>
                  <Div textAlign="center" p={{ r: { xs: "0", md: " 3rem" } }}>
                    <ImageLink link={content.imgLink}>
                      <Div
                        d={{ xs: "none", md: "block" }}
                        bgImg={content.img}
                        bgSize="contain"
                        bgPos="center"
                        p={{ b: "18.75rem" }}
                        bgRepeat="no-repeat"
                      ></Div>
                    </ImageLink>
                    <Div
                      m={{ t: "3rem" }}
                      // p={{ b: "11.6rem" }}
                    >
                      <Player
                        {...buzzVideoParams}
                        className="video-modal"
                        poster={content.videoPoster}
                      >
                        <source src={content.videoLink} />
                        <ControlBar>
                          <CurrentTimeDisplay order={4.1} />
                          <TimeDivider order={4.2} />
                          <VolumeMenuButton order={8} />
                        </ControlBar>
                      </Player>
                    </Div>
                  </Div>
                </Col>
                <Col size={{ xs: "12", md: "7" }}>
                  <Div
                    d="flex"
                    flexDir="column"
                    justify="flex-end"
                    p={{ l: { xs: "0", md: "2.25rem" } }}
                  >
                    <Text
                      textSize={{ xs: "title2", md: "display5" }}
                      maxW="24.75rem"
                      textWeight="700"
                      m={{ t: { xs: "2rem", md: "6.3rem" } }}
                      tag="h2"
                    >
                      {content.heading}
                    </Text>
                    <Text textSize="paragraph" m={{ t: ".8rem" }}>
                      {content.text}
                    </Text>
                    <Div
                      d={{ xs: "flex", md: "block" }}
                      m={{ t: { xs: "2rem", md: "0" } }}
                    >
                      <Div
                        m={{ t: { xs: ".8rem", md: "2.3rem" } }}
                        flexGrow="1 1 50%"
                        d="flex"
                        maxW="27rem"
                        flexDir={{ xs: "column", md: "row" }}
                        justify="space-between"
                      >
                        {content.info.map((data, id) => {
                          return (
                            <Div m={{ b: { xs: "2rem", md: "0" } }}>
                              <Text textSize="display4" textWeight="700">
                                {data.text1}
                              </Text>
                              <Text
                                textWeight="700"
                                textColor="gray700"
                                fontFamily="secondary"
                              >
                                {data.text2}
                              </Text>
                            </Div>
                          );
                        })}
                      </Div>
                      <Div d={{ xs: "block", md: "none" }} flexGrow="1 1 50%">
                        <ImageLink link={content.imgLink}>
                          <Div
                            bgImg={content.img}
                            p={{ b: "81%" }}
                            bgSize="contain"
                            bgRepeat="no-repeat"
                            bgPos="center"
                          ></Div>
                        </ImageLink>
                      </Div>
                    </Div>
                    <Link to={content.buttonLink}>
                      <Button
                        m={{ t: { xs: "0", md: "2rem" } }}
                        h="3rem"
                        p={{ x: "1.2rem" }}
                        bg="primary"
                        hoverBg="#FFCB6F"
                        textColor="black"
                        textWeight="800"
                        fontFamily="secondary"
                        rounded="xs"
                        w={{ xs: "100%", md: "auto" }}
                      >
                        {content.buttonText}
                      </Button>
                    </Link>
                  </Div>
                </Col>
              </Row>
            </CustomContainer>
          </WebsiteContainer>
        </Div>
      </Div>
    );
  }
}
